import {Injectable} from '@angular/core';
import {Subject} from "rxjs";
import {FilterControl} from "../interface/filter-control";

@Injectable({
  providedIn: 'root'
})
export class StoreFilterControlService {

  constructor() { }

  public storedControl:Subject<FilterControl> = new Subject();
}
